import { ListeTable } from '@mairistem/liste';
import { newIdentifiant } from '@mairistem/tools';
import _ from 'lodash';
import React, { type ReactNode } from 'react';

import type { RegieRegisseurType } from '@/types';
import RegieMandataireListeTableRow from './RegieMandataireListeTableRow';

type RegieMandataireListeTableProps = {
  mandataires: RegieRegisseurType[];
  onRegisseurEdit: (regisseur: RegieRegisseurType) => void;
  onRegisseurRemove: (regisseur: RegieRegisseurType) => void;
};

const RegieMandataireListeTable = (props: RegieMandataireListeTableProps) => {
  const { mandataires, onRegisseurEdit, onRegisseurRemove } = props;

  const [sorts, setSorts] = React.useState({});

  const handleSort = React.useCallback(
    (sort) => {
      setSorts(
        _.isEmpty(sort)
          ? // tri par défaut
            {
              actif: 'desc',
              mandat: 'desc',
              nom: 'asc',
              prenom: 'asc',
            }
          : _.mapValues(sort, (val) => (val === 'ascending' ? 'asc' : 'desc')),
      );
    },
    [setSorts],
  );

  const renderRow = (item, __, rowProps) => (
    <RegieMandataireListeTableRow
      item={item}
      onRegisseurEdit={onRegisseurEdit}
      onRegisseurRemove={onRegisseurRemove}
      rowProps={rowProps}
    />
  );

  const formatedMandataires = React.useMemo(
    () =>
      _.map(mandataires, ({ identifiant, nom, prenom, ...rest }) => ({
        // Les nouveaux n'ont pas d'identifiant, mais la liste a besoin d'un identifiant
        identifiant: identifiant || newIdentifiant(),
        nom: _.upperFirst(_.toLower(nom)),
        prenom: _.upperFirst(_.toLower(prenom)),
        ...rest,
      })),
    [mandataires],
  );

  const orderedMandataires = React.useMemo(
    () => _.orderBy(formatedMandataires, _.keys(sorts), _.values(sorts)),
    [formatedMandataires, sorts],
  );

  return (
    <div style={{ height: 250 }}>
      <ListeTable
        count={_.isEmpty(orderedMandataires) ? 0 : _.size(mandataires)}
        items={_.map(orderedMandataires, ({ identifiant, ...rest }) => ({
          ...rest,
          // Les nouveaux n'ont pas d'identifiant, mais la liste a besoin d'un identifiant
          identifiant: identifiant || newIdentifiant(),
        }))}
        noResultsMessage="Aucun mandataire"
        noResultsIcon="dont"
        loading={false}
        onSort={handleSort}
      >
        <ListeTable.Header>
          <ListeTable.Column name="nom" sortable width={7}>
            Nom et prénom
          </ListeTable.Column>
          <ListeTable.Column name="mandat" sortable width={5}>
            Mandat
          </ListeTable.Column>
          <ListeTable.Column name="actif" sortable textAlign="center" width={4}>
            Actif
          </ListeTable.Column>
        </ListeTable.Header>
        {renderRow as unknown as ReactNode}
      </ListeTable>
    </div>
  );
};

export default RegieMandataireListeTable;
